// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  PRODUCTION: true,
  // apiUrl: 'http://amosi.amiss.com.vn/SERVICE/api/ExcuteOracle',
  //apiUrl: 'http://192.168.1.230:50001/',
  API_URL:"http://192.168.1.233:45001/",
  // apiUrl: "http://amiss4.ifc.com.vn:1005/ServiceAmiss4/",
  LOCAL_USER_NAME: "UserInfo",
  SESSION_DANHMUC_NAME: "selectedDirectory",
  IP_ADDRESS: "ipAddress",
  TIM_KIEM_KEY: "timKiemValue",
  CHUYEN_TRANG_NAME:"isThongKeDangNhap",
  ACCOUNT_ID:"AccountID",
  ACCOUNT_NAME:"AccountName",
  FROMDATE:"FromDate",
  TODATE:"ToDate", 
  LANGUAGE: "LANGUAGE",
  version: 'DEV',
  DsKhachHang: 'DsKhachHang',
  TimeOut: 'TimeOut',
  timKiemKey:"timKiemValue",
  google_analytics_code: 'UA-136260204-1'
};





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/environments/environment.ts